import styled from "styled-components";

export const Container = styled('div')`
    display: inline-block;
    .btn {
        border: none;
        border-radius: 100px;
        padding: 6px 25px;
        transition: all .2s;
        font-size: 1rem;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 5px;
        position: relative;
    }

    .btn:hover {
        transform: translateY(0px);
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    }

    .btn:active {
        transform: translateY(-2px);
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    }

    .btn-white {
        background-color: ${props => props.theme.colors.primary};
        color: white;
    }

    .btn::after {
        content: "";
        display: inline-block;
        height: 100%;
        width: 100%;
        border-radius: 100px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        transition: all .4s;
    }

    .btn-white::after {
        background-color: ${props => props.theme.colors.primary};
        opacity: .2;
    }

    .btn:hover::after {
        transform: scaleX(1.2) scaleY(1.2);
        opacity: 0;
    }

    .btn-animate {
        animation: moveInBottom 1s ease-out;
        animation-fill-mode: backwards;

        & > svg {
            color: white !important;
        }
    }

    @keyframes moveInBottom {
        0% {
            opacity: 0;
            transform: translateY(30px);
        }

        100% {
            opacity: 1;
            transform: translateY(0px);
        }
    }
`;